'use client';

import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { invalidateNotificationByUser } from '@/hooks/apps/notification/invalidate';
import { useFcm } from '@/hooks/apps/notification/useFCM';
import { useAppSelector } from '@/redux-store/hooks';

export default function NotificationEventBridge() {
    const qc = useQueryClient();
    const userId = useAppSelector(s => s.auth.user?.id);

    const onNotifEvent = useCallback(() => {
        if (!userId) return;

        invalidateNotificationByUser(qc, userId);
    }, [qc, userId]);

    useFcm({
        enabled: !!userId,
        onEvent: onNotifEvent,
    });

    return null;
}
